import { render } from "./ViewContact.vue?vue&type=template&id=6f9ac3d8&scoped=true"
import script from "./ViewContact.vue?vue&type=script&lang=js"
export * from "./ViewContact.vue?vue&type=script&lang=js"

import "./ViewContact.vue?vue&type=style&index=0&id=6f9ac3d8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9ac3d8"]])

export default __exports__